import { QUOTES_TYPE } from "../types/index.const";
import biaFiltersByProduct from "./biaFormFilter.strategy";
import crossConnectFormFilterStrategy from "./crossConnectFormFilter.strategy";
import diaFormFilterByProduct from "./diaFormFilter.strategy";
import eplFormFilterStrategy from "./eplFormFilter.strategy";
import fieldServiceFilterByProduct from "./fieldSeviceFilterForm.strategy";
import hardwareFilterForm from "./hardwareFilterForm";
import iptFilterByProduct from "./iptFormFilter.strategy";
import rackAndSpaceFilterByProduct from "./rackFormFilter.strtegy";
import wiaFilterByProduct from "./wiaFormFilter.strategy";

const formElementsByProductType = {
  [QUOTES_TYPE[0]]: diaFormFilterByProduct,
  [QUOTES_TYPE[1]]: iptFilterByProduct,
  [QUOTES_TYPE[2]]: biaFiltersByProduct,
  [QUOTES_TYPE[3]]: wiaFilterByProduct,
  [QUOTES_TYPE[4]]: [],
  [QUOTES_TYPE[5]]: eplFormFilterStrategy,
  [QUOTES_TYPE[6]]: eplFormFilterStrategy,
  [QUOTES_TYPE[7]]: hardwareFilterForm,
  [QUOTES_TYPE[8]]: fieldServiceFilterByProduct,
  [QUOTES_TYPE[9]]: rackAndSpaceFilterByProduct,
  [QUOTES_TYPE[10]]: crossConnectFormFilterStrategy,
};
export default formElementsByProductType;
